export default function convertToItalianDate(date) {
  const d = date.split('-');
  return `${d[2]}-${d[1]}-${d[0]}`;
}
